import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Avatar } from "@mui/material";
import logo_icon from '../../assets/images/Logo/Bharat-Darshan-Logo.png';
import * as OperatorImageActions from '../../redux/actions/operatorImageAction';

const AddOperatorImages = ({ mode }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const stateData = location?.state?.stateData;
    const dispatch = useDispatch();
    const { operatorData } = useSelector(state => state?.operatorImageReducer);

    const [operator, setOperator] = useState({ _id: '', name: '' });

    const [inputFieldDetail, setInputFieldDetail] = useState({ operatorName: Object.keys(stateData).length > 0 ? stateData?.OperatorName : '', operatorCode: Object.keys(stateData).length > 0 ? stateData?.OperatorCode : '', minAmount: Object.keys(stateData).length > 0 ? stateData?.minAmount : '', maxAmount: Object.keys(stateData).length > 0 ? stateData?.maxAmount : '', city: Object.keys(stateData).length > 0 ? stateData?.city : '' });
    const [inputFieldError, setInputFieldError] = useState({ operator: '', operatorName: '', operatorCode: '', minAmount: '', maxAmount: '', city: '' });
    const [image, setImage] = useState({ file: stateData ? stateData?.operatorImage : logo_icon, bytes: "" });

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    }

    //* Handle Input Field : Data
    const handleInputField = (e) => {
        const { name, value } = e.target;
        setInputFieldDetail({ ...inputFieldDetail, [name]: value });
    };

    //* Handle Image
    const handleImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage({
                file: URL.createObjectURL(e.target.files[0]),
                bytes: e.target.files[0],
            });
        }

        handleInputFieldError("image", null)
    };

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true;
        const { operatorName, operatorCode, minAmount, maxAmount } = inputFieldDetail;
        const { file } = image;

        if (!operator?._id) {
            handleInputFieldError("operator", "Please Select Operator")
            isValid = false;
        }
        if (!operatorName) {
            handleInputFieldError("operatorName", "Please Enter Operator Name")
            isValid = false;
        }
        if (!operatorCode) {
            handleInputFieldError("operatorCode", "Please Enter Operator Code")
            isValid = false;
        }
        if (!minAmount) {
            handleInputFieldError("minAmount", "Please Enter Minimum Amount")
            isValid = false;
        }
        if (minAmount < 0) {
            handleInputFieldError("minAmount", "Please Enter Amount Greater Than 0")
            isValid = false;
        }
        if (!maxAmount) {
            handleInputFieldError("maxAmount", "Please Enter Maximum Amount")
            isValid = false;
        }
        if (maxAmount < 0) {
            handleInputFieldError("maxAmount", "Please Enter Amount Greater Than 0")
            isValid = false;
        }
        if (maxAmount < minAmount) {
            handleInputFieldError("maxAmount", "Please Enter Amount Greater Than Minimum Amount")
            isValid = false;
        }
        if (!file) {
            handleInputFieldError("image", "Please Select Image")
            isValid = false;
        }

        return isValid;
    };

    //! Handle Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setInputFieldError({ operator: '', operatorName: '', operatorCode: '', minAmount: '', maxAmount: '', city: '' })
            console.log("Input Data :: ", { ...inputFieldDetail, image, operator })
            const { operatorName, operatorCode, minAmount, maxAmount, city } = inputFieldDetail;
            console.log(Object.keys(stateData).length)
            if (Object.keys(stateData).length > 0) {
                let formData = new FormData()
                formData.append('operatorId', stateData?._id)
                formData.append('minAmount', minAmount);
                formData.append('maxAmount', maxAmount);
                operator?.name == 'Electricity' && formData.append('city', city);
                formData.append('images', image?.bytes);

                const payload = {
                    data: formData,
                    onComplete: () => navigate("/operator-images")
                }

                //! Dispatching API for Updating
                dispatch(OperatorImageActions.updateOperatorImages(payload));

            } else {
                let formData = new FormData()
                formData.append('servicesType', operator?._id);
                formData.append('OperatorName', operatorName);
                formData.append('OperatorCode', operatorCode);
                formData.append('minAmount', minAmount);
                formData.append('maxAmount', maxAmount);
                operator?.name == 'Electricity' && formData.append('city', city);
                formData.append('images', image?.bytes);

                const payload = {
                    data: formData,
                    onComplete: () => navigate("/operator-images")
                }

                //! Dispatching API for Creating
                dispatch(OperatorImageActions.createOperatorImages(payload));
            }
        }
    };

    useEffect(() => {
        //! Dispatching API for Get Operator
        dispatch(OperatorImageActions.getOperator());
    }, [])

    useEffect(() => {
        if (Object.keys(stateData).length > 0) {
            setOperator(operatorData.find(item => item?.name === stateData?.servicesTypeDetails?.name))
        }
    }, [operatorData, stateData]);

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>{mode} Operator Image</div>
                    <div onClick={() => navigate("/operator-images")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
                </div>

                <Grid container sx={{ alignItems: "center" }} spacing={3}>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <FormControl fullWidth>
                            <InputLabel id="select-label">Select Operator</InputLabel>
                            <Select
                                label="Select Operator" variant="outlined" fullWidth
                                name='operator'
                                value={operator?._id}
                                disabled={Object.keys(stateData).length > 0}
                                onChange={(e) => setOperator(operatorData.find(item => item._id === e.target.value))}
                                error={inputFieldError.operator ? true : false}
                                onFocus={() => handleInputFieldError("operator", null)}
                            >
                                <MenuItem disabled>---Select Operator---</MenuItem>
                                {operatorData && operatorData?.map((value, index) => <MenuItem key={value?._id} value={value?._id}>{value?.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                        {inputFieldError?.operator && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.operator}</div>}
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Operator Name" variant='outlined' fullWidth
                            name='operatorName'
                            disabled={Object.keys(stateData).length > 0}
                            value={inputFieldDetail?.operatorName}
                            onChange={handleInputField}
                            error={inputFieldError.operatorName ? true : false}
                            helperText={inputFieldError.operatorName}
                            onFocus={() => handleInputFieldError("operatorName", null)}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Operator Code" variant='outlined' fullWidth
                            name='operatorCode'
                            disabled={Object.keys(stateData).length > 0}
                            value={inputFieldDetail?.operatorCode}
                            onChange={handleInputField}
                            error={inputFieldError.operatorCode ? true : false}
                            helperText={inputFieldError.operatorCode}
                            onFocus={() => handleInputFieldError("operatorCode", null)}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                            <Grid item xs={2} >
                                <Avatar src={image.file} style={{ width: 40, height: 40 }} />
                            </Grid>
                            <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                                Upload Category Image
                                <input onChange={handleImage} hidden accept="image/*" type="file" />
                            </Grid>
                        </Grid>
                        {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Minimum Amount" variant='outlined' fullWidth type="number"
                            name='minAmount'
                            value={inputFieldDetail?.minAmount}
                            onChange={(e) => {
                                handleInputField(e)
                                if (e.target.value < 0) {
                                    handleInputFieldError("minAmount", "Please Enter Amount Greater Than 0")
                                } else {
                                    handleInputFieldError("minAmount", null)
                                }
                            }}
                            error={inputFieldError.minAmount ? true : false}
                            helperText={inputFieldError.minAmount}
                            onFocus={() => handleInputFieldError("minAmount", null)}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Maximum Amount" variant='outlined' fullWidth type="number"
                            name='maxAmount'
                            value={inputFieldDetail?.maxAmount}
                            onChange={(e) => {
                                handleInputField(e)
                                if (e.target.value < 0) {
                                    handleInputFieldError("maxAmount", "Please Enter Amount Greater Than 0")
                                } else {
                                    handleInputFieldError("maxAmount", null)
                                }
                            }}
                            error={inputFieldError.maxAmount ? true : false}
                            helperText={inputFieldError.maxAmount}
                            onFocus={() => handleInputFieldError("maxAmount", null)}
                        />
                    </Grid>

                    {operator && operator?.name == 'Electricity' && <Grid item lg={6} md={6} sm={12} xs={12} >
                        < TextField
                            label="City" variant='outlined' fullWidth
                            name='city'
                            value={inputFieldDetail?.city}
                            onChange={handleInputField}
                            error={inputFieldError.city ? true : false}
                            helperText={inputFieldError.city}
                            onFocus={() => handleInputFieldError("city", null)}
                        />
                    </Grid>}

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container sx={{ justifyContent: "space-between" }}>
                            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
                        </Grid>
                    </Grid>
                </Grid>
            </div >
        </>

    );
};

export default AddOperatorImages;